import { render, staticRenderFns } from "./MarketingCard.vue?vue&type=template&id=8c30d7dc&scoped=true"
import script from "./MarketingCard.vue?vue&type=script&lang=js"
export * from "./MarketingCard.vue?vue&type=script&lang=js"
import style0 from "./MarketingCard.vue?vue&type=style&index=0&id=8c30d7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c30d7dc",
  null
  
)

export default component.exports